import { makeStyles } from "tss-react/mui"
import { Stack, Typography, Grid } from "@mui/material"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import logoUrl from "../assets/logo.png"

const useStyles = makeStyles()((theme) => ({
    titleWrap: {
        position: "relative",
        background: theme.palette.tailwind.slate[900],
        color: theme.palette.tailwind.slate[50],
        borderRight: `1px solid ${theme.palette.tailwind.slate[50]}`,
        boxSizing: "border-box",
        padding: "2rem 1.5rem",
    },
    logoWrap: {
        width: "3.125rem",
        height: "3.125rem",
        position: "absolute",
        left: "50%",
        top: 0,
        transform: "translate(-50%, -50%)",
        background: theme.palette.tailwind.slate[900],
        border: `1px solid ${theme.palette.tailwind.slate[800]}`,
        borderRadius: "100%",
    },
    image: {
        width: "1.625rem",
        objectFit: "contain",
    },
    title: {
        lineHeight: 1,
        textTransform: "uppercase",
        textAlign: "center",
    },
}))

export function TitleSection() {
    const { classes } = useStyles()

    return (
        <Stack justifyContent="center" className={classes.titleWrap}>
            <Grid container justifyContent="center" alignItems="center" className={classes.logoWrap}>
                <img src={logoUrl} alt="Logo" className={classes.image} />
            </Grid>
            <LocalizedStrict id="merchant-home-views-dialog-conference-live-sales-part-1">
                <Typography variant="h5" className={classes.title}>
                    Live
                </Typography>
            </LocalizedStrict>
            <LocalizedStrict id="merchant-home-views-dialog-conference-live-sales-part-2">
                <Typography variant="h5" className={classes.title}>
                    sales
                </Typography>
            </LocalizedStrict>
        </Stack>
    )
}
